import { useQueryClient } from '@tanstack/react-query';
import keys from './keys';
import useApiMutation from '../useApiMutation';

const useSetJiosaavn = () => {
  const queryClient = useQueryClient();

  const disableJiosaavn = useApiMutation({
    getRequestUrl: ({ showId } = {}) => `/shows/${showId}/jiosaavn`,
    method: 'DELETE',
    onSuccess: (newShowData) => {
      queryClient.setQueryData(keys(newShowData.showId).show, newShowData);
    },
  });

  const enableJiosaavn = useApiMutation({
    getRequestUrl: ({ showId } = {}) => `/shows/${showId}/jiosaavn`,
    method: 'POST',
    onSuccess: (newShowData) => {
      queryClient.setQueryData(keys(newShowData.showId).show, newShowData);
    },
  });

  return {
    disableJiosaavn: disableJiosaavn.mutate,
    isDisableJiosaavnLoading: disableJiosaavn.isLoading,
    isDisableJiosaavnError: disableJiosaavn.isError,
    isDisableJiosaavnSuccess: disableJiosaavn.isSuccess,
    disableJiosaavnInfo: { ...disableJiosaavn },

    enableJiosaavn: enableJiosaavn.mutate,
    isEnableJiosaavnLoading: enableJiosaavn.isLoading,
    isEnableJiosaavnError: enableJiosaavn.isError,
    isEnableJiosaavnSuccess: enableJiosaavn.isSuccess,
    enableJiosaavnInfo: { ...enableJiosaavn },
  };
};

export default useSetJiosaavn;
